export interface BusinessTypeMeta {
  /** URL slug and `page.business_types.<slug>` i18n namespace, e.g. 'pet-grooming'. */
  slug: string
  /** Underscore key matching the existing `page.services.showcase` / `page.home.one_platform.business_types` namespaces, e.g. 'pet_grooming'. */
  i18nKey: string
  accent: string
  /** Hero photo for the built page. Omitted for types with no photo shot yet. */
  image?: string
  icon: string
  /** Whether a dedicated page exists yet. Unbuilt types render a "coming soon" page. */
  built: boolean
}

const BUSINESS_TYPES: BusinessTypeMeta[] = [
  { slug: 'salon', i18nKey: 'salon', accent: '#CB2097', image: '/services/salon.jpg', icon: '/types-icons/salon.svg', built: true },
  { slug: 'barber', i18nKey: 'barber', accent: '#2E83FB', image: '/services/barber.jpg', icon: '/types-icons/barber.svg', built: true },
  { slug: 'massage', i18nKey: 'massage', accent: '#10B981', image: '/services/massage.jpg', icon: '/types-icons/massage.svg', built: true },
  { slug: 'nails', i18nKey: 'nails', accent: '#F59E0B', image: '/services/nails.jpg', icon: '/types-icons/nails.svg', built: true },
  { slug: 'pet-grooming', i18nKey: 'pet_grooming', accent: '#8B5CF6', image: '/services/pet-grooming.jpg', icon: '/types-icons/pet.svg', built: true },
  { slug: 'spa-sauna', i18nKey: 'spa_sauna', accent: '#0EA5E9', image: '/services/spa.jpg', icon: '/types-icons/spa.svg', built: true },
  { slug: 'gym', i18nKey: 'gym', accent: '#EF4444', image: '/services/gym.jpg', icon: '/types-icons/gym.svg', built: true },
  { slug: 'medical-center', i18nKey: 'medical_center', accent: '#6366F1', image: '/services/medical.jpg', icon: '/types-icons/medical.svg', built: true },
  { slug: 'physiotherapy', i18nKey: 'physiotherapy', accent: '#14B8A6', image: '/services/physiotherapy.jpg', icon: '/types-icons/physiotherapy.svg', built: true },
]

export function useBusinessTypes() {
  return BUSINESS_TYPES
}

export function useBusinessType(slug: string) {
  return BUSINESS_TYPES.find(b => b.slug === slug)
}
